<template>
    <PageBase title="Ambitiethema milieu- en klimaatimpact" description="" :valid="valid" @show-error="showError" :right-button-classes="'mr-12'" :show-right-margin="false">
      <div class="flex gap-4 xl:-mt-6 mr-12">
        <div class="flex-1"></div>
        <div class="text-base -mt-2 text-right w-64 xl:w-auto xl:mt-2">Dit ambitiethema meenemen in de aanvraag?</div>

        <JaNeeToggleButton v-model="store.registrationData.prioriteringsThemas.milieu" />
      </div>

      <div class="flex flex-col gap-3 max-h-[calc(100vh-270px)] overflow-y-auto overflow-x-hidden pr-12">

        <div class="flex flex-col-reverse lg:flex-row gap-5">
            <div class="flex-1">
              <img class="object-contain" src="/src/assets/Milieu_impact.png" />
            </div>
          <div class="flex-1 flex flex-col gap-4">

      <div class="text-sm italic">Het generieke Programma van Eisen (PvE) voor scholen biedt een
flexibel raamwerk dat eenvoudig kan worden afgestemd op de
specifieke wensen van gemeenten en schoolbesturen. Dit gebeurt aan
de hand van verschillende ambitie-opties, zoals de optie voor milieuen
klimaatimpact. Met deze keuze kunnen opdrachtgevers sterker
sturen op de milieubelasting en klimaatimpact.
      </div>

      <div class="text-sm">Binnen de milieu-impact gaat het om zowel de klimaatimpact
(materiaalgebonden CO2-uitstoot) als de integrale milieu-impact.
Een groot deel van de totale impact van een school is het gevolg
van ontwerp- en materiaalkeuzes. Denk daarbij aan de keuze voor
het soort materiaal (voorbeeld: hout in plaats van beton) of de
bouwtechniek (voorbeeld: CO2-arm beton).</div>

      <div class="text-sm">Sturing op de klimaatimpact beperkt de bijdrage aan de opwarming
van de aarde, als gevolg van productie van bouwmaterialen en
uitvoering van bouwwerkzaamheden. De focus ligt hierbij op het
beperken van de korte-termijn materiaalgebonden CO2-uitstoot.</div>

      <div class="text-sm">Sturing op de integrale milieu-impact beperkt de bredere impact
op het milieu. Daarbij wordt gekeken naar de hele levenscyclus:
van de productie van bouwmaterialen tot en met de toekomstige
hergebruikpotentie. Deze sturing op de hele levenscyclus, inclusief
tussentijdse vervangingen, is aanvullend op sturing op de kortetermijn
impact.</div>

        <div class="text-sm">De klimaatimpact wordt gemeten middels de milieuprestatie gebouw
(MPG), de materiaal-gebonden CO2 en CO2 opslag en tot slot de
toepassing van biobased, hergebruikte en gerecyclede materialen.
Op dit moment zijn er nog weinig presentatie-eisen vastgelegd
in wet- en regelgeving (bouwbesluit) maar meer sturen op deze
onderdelen is noodzakelijk om toe te werken naar de Europese
klimaatdoelen. Een duidelijke sturing vanaf de start van het proces
kan de klimaatimpact flink verlagen. Hier heeft het PvE van POHV
een eerste stap in gezet die een haalbare ambitie in zich heeft.</div>
</div>

</div>

    </div>
  </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue'
import { useRegistrationStore } from '@/stores/registration'
import { ref } from 'vue';
import JaNeeToggleButton from '@/components/JaNeeToggleButton.vue';
const errorsShown = ref(false)
const valid = ref(true)

const store = useRegistrationStore()

function showError() {
  errorsShown.value = true
}
</script>
